import { createDomain, Domain, sample } from 'effector';
import { delay } from 'patronum';

const dialogDomain = createDomain();

type DialogFactoryParams = {
   domain?: Domain;
};

export const createDialog = <T>({ domain = dialogDomain }: DialogFactoryParams) => {
   const $opened = domain.createStore(false);
   const $state = domain.createStore<T | null>(null);
   const open = domain.createEvent<T>();
   const close = domain.createEvent();
   const toggle = domain.createEvent();

   const wasClosed = sample({
      clock: [close, toggle],
      source: $opened,
      filter: opened => !opened,
      fn: () => {},
   });

   $state.on(open, (_, param) => param ?? null).reset(delay(wasClosed, 300));

   $opened
      .on(open, () => true)
      .on(close, () => false)
      .on(toggle, opened => !opened);

   return {
      $opened,
      close,
      open,
      toggle,
      wasClosed,
      $state,
   };
};
